import { useMemo } from 'react'
import HelpIcon from '@mui/icons-material/Help'
import HelpDialog from '../../HelpDialog'
const pdfFile = require('./ComplaintTrendsOverview.pdf')


export default function ComplaintTrendsHelp() {
  const file = useMemo(() => pdfFile, [])
  

  return (
    <>
    <HelpDialog linkText='Help' startIcon={<HelpIcon />} fullScreen={true}>
        <iframe title="Complaint Trends Help" src={file} width={'100%'} style={{ aspectRatio: '100%', minHeight: '80vh'}}></iframe>
    </HelpDialog>
    </>
  )
}